import { Button } from 'primereact/button'
import { PropsWithChildren } from 'react'
import { LoadingIcon, SaveIcon } from '../Icons'
import { classNames } from 'primereact/utils'

type SaveButtonProps = {
  title?: string
  label?: string
  loading?: boolean
  disabled?: boolean
  onClick?: () => void
  dataPrAt?: string
}

const SaveButton = ({ title, label, disabled, loading, onClick, dataPrAt }: SaveButtonProps & PropsWithChildren) => {
  if (dataPrAt === undefined) {
    dataPrAt = 'center+5 bottom'
  }

  return (
    <Button
      onClick={onClick}
      severity="secondary"
      className={classNames("cursor-pointer", { 'button': label, 'icon-button': !label })}
      type="submit"
      disabled={loading || disabled}
      title={title}
      tooltip={title}
      tooltipOptions={{ position: 'bottom' }}
      data-pr-at={dataPrAt}
      pt={{
        label: { className: 'text-white' },
      }}
    >
      {loading && <LoadingIcon className="h-4 w-4 fill-white animate-spin" />}
      {!loading && <SaveIcon className="fill-white cursor-pointer h-5 w-5" />}
      {label && <span className="">{label}</span>}
    </Button >
  )
}

export default SaveButton
